import React from 'react';
import {toast} from 'react-toastify';

// Toast notification helpers
export default {

  lastToast: null,

  error(msg) {
    return toast.error((
      <label className='h8'><span className='icon icon-check-white' />{msg}</label>
    ), {
      autoClose: 5000,
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true
    });
  },

  success(msg = 'Success!') {
    this.dismissLast();
    this.lastToast = toast.success((
      <label className='h8'><span className='icon icon-check-white' />{msg}</label>
    ), {
      autoClose: 1500,
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true
    });
    return this.lastToast;
  },

  info(msg = 'Info') {
    this.dismissLast();
    this.lastToast = toast.info((
      <label className='h8'><span className='icon icon-check-white' />{msg}</label>
    ), {
      autoClose: 5000,
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true
    });
    return this.lastToast;
  },

  dismissLast() {
    if (this.lastToast) {
      toast.dismiss( this.lastToast );
    }
    this.lastToast = null;
  }

};



// WEBPACK FOOTER //
// ./src/utils/notify.js